import { combineReducers } from '@shared/redux';
import { convertArrayToHash } from '../../shared/utils/array';
import { GOALS_TYPE } from './goals.constants';
import {
    excludeGoalByEntityTypeAndEntityId,
    filterGoalsByEntityTypeAndEntityId,
} from './goals.utils';
import { goalsManagementModalReducer } from './goals-management-modal/goals-management-modal.state';

const GET_GOALS = 'GET_GOALS';
const EDIT_GOAL = 'EDIT_GOAL';
const SET_GOALS_FILTERS = 'SET_GOALS_FILTERS';
const RESET_GOALS_TO_INITIAL_STATE = 'RESET_GOALS_TO_INITIAL_STATE';
const UPDATE_ACCOUNT_GOALS_ENTITY_NAME = 'UPDATE_ACCOUNT_GOALS_ENTITY_NAME';
const DELETE_GOAL_BY_ENTITY_ID = 'DELETE_GOAL_BY_ENTITY_ID';

const initialState = {
    data: {},
    filters: {
        kpi: null,
        effectiveStatus: null,
    },
};

export const setGoals = goals => ({
    type: GET_GOALS,
    payload: goals,
});

export const editGoals = goal => ({
    type: EDIT_GOAL,
    payload: goal,
});

export const setGoalsFilter = filters => ({
    type: SET_GOALS_FILTERS,
    payload: filters,
});

export const resetGoalsToInitialState = () => ({
    type: RESET_GOALS_TO_INITIAL_STATE,
});

export const updateAccountGoalsEntityName = (accountId, name) => ({
    type: UPDATE_ACCOUNT_GOALS_ENTITY_NAME,
    payload: {
        id: accountId,
        name,
    },
});

export const deleteGoalByEntityId = (entityType, entityId) => ({
    type: DELETE_GOAL_BY_ENTITY_ID,
    payload: {
        entityType,
        entityId,
    },
});


const updateAccountGoalsEntityNameReducer = (state, payload) => {
    const { id } = payload;
    const accountGoalsWithPayloadId = filterGoalsByEntityTypeAndEntityId(state.data,
        GOALS_TYPE.ACCOUNT,
        id);

    const accountGoalsWithNewEntityName = accountGoalsWithPayloadId
        .map(account => ({
            ...account,
            entity: {
                ...account.entity,
                name: payload.name,
            },
        }));

    return {
        ...state,
        data: {
            ...state.data,
            ...convertArrayToHash(accountGoalsWithNewEntityName),
        },
    };
};

// eslint-disable-next-line complexity
const goalsReducersImpl = (state = initialState, action) => {
    switch (action.type) {
    case GET_GOALS:
        return {
            ...state,
            data: {
                ...state.data,
                ...convertArrayToHash(action.payload),
            },
        };

    case EDIT_GOAL:
        return {
            ...state,
            data: {
                ...state.data,
                [action.payload.id]: {
                    ...action.payload,
                },
            },
        };

    case SET_GOALS_FILTERS:
        return {
            ...state,
            filters: {
                ...action.payload,
            },
        };

    case RESET_GOALS_TO_INITIAL_STATE:
        return initialState;

    case UPDATE_ACCOUNT_GOALS_ENTITY_NAME:
        return updateAccountGoalsEntityNameReducer(state, action.payload);

    case DELETE_GOAL_BY_ENTITY_ID:
        return {
            ...state,
            data: excludeGoalByEntityTypeAndEntityId(
                state.data, action.payload.entityType, action.payload.entityId,
            ),
        };
    default:
        return state;
    }
};

export const goalsReducers = combineReducers({
    goalsSelected: goalsReducersImpl,
    goalsManagementModal: goalsManagementModalReducer,
});
